import { useEffect, useState } from 'react';
import { referralService, ReferralOption } from '../services/referralService';

// Module-level cache: the builder mounts these editors many times per session
// and the referral list barely changes.
let cache: ReferralOption[] | null = null;
let inFlight: Promise<ReferralOption[]> | null = null;

/**
 * Referral names for the current tenant, used to offer referrals as dropdown
 * options in questionnaire configuration. Returns an empty list when the
 * request fails so callers can fall back to free text.
 */
export const useReferralOptions = (): ReferralOption[] => {
  const [options, setOptions] = useState<ReferralOption[]>(cache || []);

  useEffect(() => {
    if (cache) return;
    if (!inFlight) {
      inFlight = referralService
        .getReferralOptions()
        .then((data) => {
          cache = data;
          return data;
        })
        .catch(() => {
          cache = [];
          return [];
        })
        .finally(() => {
          inFlight = null;
        });
    }
    let active = true;
    inFlight.then((data) => {
      if (active) setOptions(data);
    });
    return () => {
      active = false;
    };
  }, []);

  return options;
};

export default useReferralOptions;
